import React, { useState, useEffect, Fragment } from "react";
import styled from "styled-components";
import {
  FolderTitle,
  ChartItem,
  SubFolders,
  Container,
  FolderList,
  Icon,
  Label,
  Stat,
  Fail,
  Warning,
  PrimaryHeading,
  HeaderLink,
  NavigatorContainer,
  GraphsContainer
} from "./Theme";
import GraphCollection from "./GraphCollection.js";

const MyContainer = styled(NavigatorContainer)``;

function Chart({ chart, onClick, selected, level }) {
  return (
    <div>
      <ChartItem onClick={onClick} selected={selected} level={level}>
        <Icon>
          <i className="fa fa-line-chart" />
        </Icon>
        <Label>{chart.label}</Label>
        <Stat>
          <Fail count={chart.fail_count}>{chart.fail_count}</Fail> /&nbsp;
          {chart.warning_count > 0 && (
            <Fragment>
              <Warning count={chart.warning_count}>{chart.warning_count}</Warning> /{" "}
            </Fragment>
          )}
          {chart.result_count}{" "}
        </Stat>
      </ChartItem>
    </div>
  );
}

function FolderContents({ folder, onClickChartItem, selectedCharts, level }) {
  if (folder.charts.length === 0 && folder.folders.length === 0) return null;
  return (
    <div>
      {folder.charts.map(c => (
        <Chart
          key={c.id}
          selected={selectedCharts.includes(c)}
          chart={c}
          onClick={() => onClickChartItem(c)}
          level={level}
        />
      ))}
      {folder.folders.map(f => (
        <Folder
          key={f.id}
          folder={f}
          onClickChartItem={onClickChartItem}
          selectedCharts={selectedCharts}
          level={level}
        />
      ))}
    </div>
  );
}

function Caret({ expanded }) {
  return expanded ? (
    <i className="fa fa-angle-down" style={{ width: 10 }} />
  ) : (
    <i className="fa fa-angle-right" style={{ width: 10 }} />
  );
}

function Folder({ folder, onClickChartItem, selectedCharts, level }) {
  const [expanded, setExpanded] = useState(folder.expanded);
  return (
    <div>
      <FolderTitle onClick={() => setExpanded(!expanded)} level={level}>
        <Icon>
          <Caret expanded={expanded} />
        </Icon>
        <Label>{folder.name}</Label>
        <Stat>
          <Fail count={folder.fail_count}>{folder.fail_count}</Fail> / {folder.result_count}{" "}
        </Stat>
      </FolderTitle>
      {expanded && (
        <SubFolders>
          <FolderContents
            folder={folder}
            onClickChartItem={onClickChartItem}
            selectedCharts={selectedCharts}
            level={level + 1}
          />
        </SubFolders>
      )}
      {expanded &&
        folder.charts.length == 0 &&
        folder.folders.length == 0 && <FolderTitle level={level}>[ no items ]</FolderTitle>}
    </div>
  );
}

export default function FolderBrowser({ folder, findSamples, simpleView = false }) {
  const [selectedCharts, setSelectedCharts] = useState([]);

  useEffect(
    () => {
      setSelectedCharts([]);
    },
    [folder]
  );

  const toggleChart = chart => {
    if (selectedCharts.includes(chart)) {
      setSelectedCharts(selectedCharts.filter(c => c !== chart));
    } else {
      setSelectedCharts([chart, ...selectedCharts]);
    }
  };

  const clearCharts = () => setSelectedCharts([]);

  return (
    <div id="browser" style={{ marginTop: 20, textAlign: "left" }}>
      <div style={{ display: "flex" }}>
        <MyContainer>
          <PrimaryHeading style={{ marginRight: 20 }}>
            <i className="fa fa-list" />
            &nbsp;&nbsp; {I18n.t("chart_navigator")}
            {selectedCharts.length > 0 && (
              <HeaderLink onClick={clearCharts}>{I18n.t("un_select_all")}</HeaderLink>
            )}
          </PrimaryHeading>
          {folder && (
            <FolderContents
              level={0}
              folder={folder}
              selectedCharts={selectedCharts}
              onClickChartItem={c => toggleChart(c)}
            />
          )}
        </MyContainer>
        <GraphCollection
          charts={selectedCharts}
          clearCharts={clearCharts}
          findSamples={findSamples}
          removeChart={toggleChart}
          simpleView={simpleView}
        />
      </div>
    </div>
  );
}
